<div class="component-container">
  <div class="header-row px-[2rem] flex flex-row justify-between items-center">
    <div class="left-side w-1/3">
      <app-shimmer-loader
        [count]="1"
        [theme]="{'height': '5rem'}"
        appearance="line"
        class="line"
      ></app-shimmer-loader>
      <app-shimmer-loader
        [count]="1"
        [theme]="{'height': '5rem'}"
        appearance="line"
        class="line"
      ></app-shimmer-loader>
    </div>
    <div class="right-side w-1/3">
      <app-shimmer-loader
        [count]="1"
        [theme]="{'height': '5rem'}"
        appearance="line"
        class="line"
      ></app-shimmer-loader>
    </div>
  </div>
  <hr class="hr">

  <div class="week-summary w-full px-[2rem]">
    <app-shimmer-loader
      [count]="1"
      [theme]="{'height': '5rem'}"
      appearance="line"
      class="line"
    ></app-shimmer-loader>
  </div>
  <div
    class="graph-section px-[2rem] flex flex-col lg:flex-row justify-between items-center gap-[1rem]">
    <div class="card lg:w-1/3 w-full">
      <app-shimmer-loader
        [count]="1"
        [theme]="{'height': '25rem'}"
        appearance="line"
        class="line"
      ></app-shimmer-loader>
    </div>
    <div class="card lg:w-1/3 w-full">
      <app-shimmer-loader
        [count]="1"
        [theme]="{'height': '25rem'}"
        appearance="line"
        class="line"
      ></app-shimmer-loader>
    </div>
    <div class="card lg:w-1/3 w-full">
      <app-shimmer-loader
        [count]="1"
        [theme]="{'height': '25rem'}"
        appearance="line"
        class="line"
      ></app-shimmer-loader>
    </div>
  </div>
  <hr class="hr">
  <div class="daily-total-section w-full px-[2rem]">
    <app-shimmer-loader
      [count]="1"
      [theme]="{'height': '5rem'}"
      appearance="line"
      class="line"
    ></app-shimmer-loader>
  </div>
  <div class="day-slider w-full px-[2rem]">
    <app-shimmer-loader
      [count]="1"
      [theme]="{'height': '5rem'}"
      appearance="line"
      class="line"
    ></app-shimmer-loader>
  </div>
  <div
    class="graph-section px-[2rem] flex flex-row justify-between items-center gap-[1rem]">
    <div class="card lg:w-1/3 w-full">
      <app-shimmer-loader
        [count]="1"
        [theme]="{'height': '25rem'}"
        appearance="line"
        class="line"
      ></app-shimmer-loader>
    </div>
    <div class="card lg:w-1/3 w-full">
      <app-shimmer-loader
        [count]="1"
        [theme]="{'height': '25rem'}"
        appearance="line"
        class="line"
      ></app-shimmer-loader>
    </div>
    <div class="card lg:w-1/3 w-full">
      <app-shimmer-loader
        [count]="1"
        [theme]="{'height': '25rem'}"
        appearance="line"
        class="line"
      ></app-shimmer-loader>
    </div>
  </div>
  <hr class="hr">
  <div class="resource-section w-full">
    <div class="resource-header-section w-full px-[2rem]">
      <app-shimmer-loader
        [count]="1"
        [theme]="{'height': '5rem'}"
        appearance="line"
        class="line"
      ></app-shimmer-loader>
    </div>
    <div
      class="graph-section px-[5rem] flex flex-row justify-between items-center gap-[1rem]">
      <div class="card w-1/3">
        <app-shimmer-loader
          [count]="1"
          [theme]="{'height': '25rem'}"
          appearance="line"
          class="line"
        ></app-shimmer-loader>
      </div>
      <div class="card w-1/3">
        <app-shimmer-loader
          [count]="1"
          [theme]="{'height': '25rem'}"
          appearance="line"
          class="line"
        ></app-shimmer-loader>
      </div>
      <div class="card w-1/3">
        <app-shimmer-loader
          [count]="1"
          [theme]="{'height': '25rem'}"
          appearance="line"
          class="line"
        ></app-shimmer-loader>
      </div>
    </div>
  </div>

</div>
